import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs))
}

export const setAppHeight = () => {
  const doc = document.documentElement
  doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}

export const tryParseJson = (stringJson: any) => {
  try {
    return JSON.parse(stringJson) as object
  } catch {
    return null
  }
}

export const joinURL = (parts: string[]) => {
  return parts
    .map((part, i) => {
      part = part.replace(/^\/+/, '')
      part = part.replace(/\/+$/, '')
      return (i > 0 ? '/' : '') + part
    })
    .join('')
}
